import {useClassWaitlistListQuery} from "~/lib/Queries";
import WaitlistEntry from "~/components/waitlist/WaitlistEntry";
import {FEATURE_WAITLIST, useFeatures} from "~/lib/Features";

const ClassWaitlistList = ({instance, className}) => {
    const {isEnabled} = useFeatures();
    const {data} = useClassWaitlistListQuery(instance?.id);

    const list = data?.list || [];

    if (!isEnabled(FEATURE_WAITLIST) || !list?.length) {
        return null;
    }

    return (
        <div className={className}>
            <div className="panel-label">Waitlist</div>
            <div className="panel pl-4">
                {list.map((entry, idx) => (
                    <WaitlistEntry
                        key={entry.id}
                        entry={entry}
                        hideTime={true}
                        isFirst={idx === 0}
                    />
                ))}
            </div>
        </div>
    )
}

export default ClassWaitlistList;
